module.exports = __webpack_public_path__ + "img/edelstahlarbeiten.646fd4dc.jpg";